/* eslint-disable import/order */
import 'urlpattern-polyfill'; // conditionally loading does not work
import 'url-search-params-polyfill';
import 'whatwg-fetch'; // fetch polyfill

import { InitializeFeatureFlags } from '@platform/ui-config';
import ReactDOM from 'react-dom';

import App from './App';
import Constants from './Auxillary/constants';
import Env from './Auxillary/environment-variables';

const initialize = async () => {
	const anonContext = { kind: 'user', key: 'anonymous-id', anonymous: true };

	const FeatureFlagProvider = await InitializeFeatureFlags({
		app: App,
		clientId: Env(Constants.FEATURE_FLAGS_KEY) ?? '',
		options: {
			bootstrap: 'localStorage',
			baseUrl: Env(Constants.FEATURE_FLAGS_URL),
			streamUrl: Env(Constants.FEATURE_FLAGS_URL),
			eventsUrl: Env(Constants.FEATURE_FLAGS_URL),
			diagnosticOptOut: false,
		},
		context: anonContext,
		maxRetries: 5,
	});

	ReactDOM.render(<FeatureFlagProvider />, document.getElementById('app'));
};

initialize();
